import logo from './logo.svg';
import './App.css';
import { List } from './List';
import React, { useState, useEffect, useReducer } from 'react';
import Admin from "./Admin"

import './App.css';

import {app,db} from "./Firebase/firebase"




import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link
} from "react-router-dom";










function App() {

  

  return (
    <div className="App">
        
  
        <nav className="navbar navbar-expand-lg navbar-dark bg-primary">
  <div className="container-fluid">
    <a className="navbar-brand" href="#">GB-TOC</a>
    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"></span>
    </button>
    <div className="collapse navbar-collapse" id="navbarNav">
      <ul className="navbar-nav">

        <li className="nav-item">
          <a className="nav-link" href="https://docs.google.com/spreadsheets/d/1NlJ0UeksQ0WMAgAoL0ykb_pKL_Oht0JhHlNCg58zDBE">Device List</a>
        </li>

        <li className="nav-item">
          <a className="nav-link disabled">Hall of Gains</a>
        </li>

        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            Support Us
          </a>
        <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
            <li><a className="dropdown-item" href="https://peakmalephysique.com/">PeakMalePhysique.com</a></li>
            <li><a className="dropdown-item" href="https://www.patreon.com/bd19962015">BD's Patreon</a></li>
            
            <li><a className="dropdown-item" href="https://www.patreon.com/dochink">Doc Hink's Patreon</a></li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</nav>
    <Router>

    <Routes>      <Route path="/" element = {<Main></Main>}>
        
      </Route>
      <Route path = "admin" element= {<Admin></Admin>} >
        
      </Route>
    </Routes>
    


   
  
     

      
    
    </Router>
    
    </div>
  );
}
const Main =()=> {

  return(
    <div className="container">

    <div className="Guides"><List> </List></div>
      <script type="application/javascript" src="https://syndication.exdynsrv.com/splash.php?idzone=4652966&capping=0"></script>
      
  </div>
  )
}

export default App;
